import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  order: 2,
  height: 'fit-content',
  width: 'fit-content',
  [theme.breakpoints.down('md')]: {
    order: 1,
    width: '100%',
  },
}));

StyledButton.defaultProps = {
  variant: 'rounded',
};
